import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { OptionType } from 'src/app/core/enums/enums';
import { PnrInfo, SearchForm } from 'src/app/core/models/itinerary.model';
import { Remarks, RemarkType, Types } from 'src/app/core/models/remarks.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { RemarksService } from 'src/app/search-result/services/remarks.service';

@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss']
})
export class RemarksComponent implements OnInit {
  @Input() isMarginTop: boolean = true;
  @Input() savedFromProccess: OptionType;

  open = false;
  tall = false;
  loading = false;
  form: FormGroup;
  REMARKS_TYPES = [
    { code: '1', name: Types.HISTORIC },
    { code: '2', name: Types.GENERIC }
  ];
  inputValue = '';
  pnrInfo: PnrInfo;
  formSearch: SearchForm;
  remarknIfo: Remarks;
  genericRemarksList: RemarkType[] = [];
  historicRemarksList: RemarkType[] = [];
  patternKey = '[A-Z a-z0-9]';

  constructor(
    private fb: FormBuilder,
    private itService: ItineraryService,
    private remarksService: RemarksService
  ) {
    this.itService
      .getPnrInfo()
      .pipe(take(1))
      .subscribe((pnr) => {
        if (pnr) {
          this.pnrInfo = pnr;
        }
      });
    this.itService
      .getSearchForm()
      .pipe(take(1))
      .subscribe((form) => {
        if (form) {
          this.formSearch = form;
        }
      });
  }

  ngOnInit(): void {
    this.buildForm();
    this.loadRemarkInfo();
  }

  handleKeypress(key: string): boolean {
    const pattern = new RegExp(this.patternKey);
    return pattern.test(key);
  }

  loadRemarkInfo(): void {
    this.remarksService
      .getRemarks()
      .pipe(take(1))
      .subscribe((remark) => {
        if (remark) {
          this.remarknIfo = remark;
          this.remarknIfo.pnrCode = this.formSearch.pnr;
          this.genericRemarksList = this.remarknIfo.remark.filter(
            (r) => r.remarkType === Types.GENERIC
          );
          this.historicRemarksList = this.remarknIfo.remark.filter(
            (r) => r.remarkType === Types.HISTORIC
          );
        } else {
          this.remarknIfo = {
            pnrCode: this.formSearch.pnr,
            remark: [],
            country: this.pnrInfo.countryCode,
            officeId: this.pnrInfo.officeId,
            gds: this.formSearch.gds,
            bookingCode: this.formSearch.bookingCode,
            transactionId: this.pnrInfo.transactionId
          };
        }
      });
  }

  buildForm(): void {
    this.form = this.fb.group({
      remarkType: [''],
      genericRemarks: this.fb.array([], Validators.required),
      historicRemarks: this.fb.array([], Validators.required)
    });
  }

  openRemarksPopUp(): void {
    this.open = true;
  }

  addRemark(): void {
    if (this.inputValue !== '') {
      const remarkType = this.form.get('remarkType').value;
      if (remarkType === '2') {
        this.addNewGenericRemark({
          remarkType: Types.GENERIC,
          text: this.inputValue
        });
      } else {
        this.addNewHistoricRemark({
          remarkType: Types.HISTORIC,
          text: this.inputValue
        });
      }
      this.remarknIfo.remark = this.historicRemarksList.concat(this.genericRemarksList);
      this.remarksService.dispatchSaveRemarksFromComponent(this.remarknIfo);
      this.inputValue = '';
      this.form.get('remarkType').setValue('');
    }
  }

  deleteGenericRemark(index: number) {
    this.genericRemarksList.splice(index, 1);
  }

  deleteHistoricRemark(index: number) {
    this.historicRemarksList.splice(index, 1);
  }

  addNewGenericRemark(remarkType: RemarkType): void {
    this.genericRemarksList.push(remarkType);
  }

  addNewHistoricRemark(remarkType: RemarkType): void {
    this.historicRemarksList.push(remarkType);
  }

  resetForm() {
    this.loading = false;
    this.form.reset();
    this.genericRemarksList = [];
    this.historicRemarksList = [];
    this.loadRemarkInfo();
    this.open = false;
  }

  saveRemarks(): void {
    this.loading = true;
    this.remarksService.dispatchCreateRemarksFromComponent(
      this.remarknIfo,
      this.formSearch.pnr,
      this.savedFromProccess
    );
    setTimeout(() => {
      this.resetForm();
    }, 3000);
  }

  isValidRemarks(): boolean {
    return this.genericRemarksList.length > 0 || this.historicRemarksList.length > 0;
  }
}
